import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject
} from '@angular/core';

import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-shipping',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'shipping.template.html'
})
export class ShippingComponent implements OnInit {

  public form: FormGroup;

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<ShippingComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  public ngOnInit(): void {
    this.form = this.formBuilder.group({
      carrier:  [this.data.carrier, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(255)
      ]],
      id:       [this.data.id, [
        Validators.required,
        Validators.minLength(3)
      ]]
    });
  }

  // Save function
  public save(value): void {
    this.dialogRef.close(this.form.value);
  }
}
